<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} EVENT CONTENT</template>
		<template #body>
			
					<div class="form-floating mb-4">
						<select v-model="form.category" class="form-select">
							<option value="">Select Category</option>
							<option value="seminars">Seminars</option>
							<option value="trc_coffee">TRC Coffee</option>
						</select>
						<label class="form-label" for="category">Category</label>
					</div>
					<div class="form-floating mb-4">
						<select v-model="form.event_type" class="form-select">
							<option value="">Select Event Type</option>
							<option value="events">Events</option>
							<option value="zoom">Zoom</option>
						</select>
						<label class="form-label" for="event_type">Event Type</label>
					</div>
					<div class="form-floating mb-4">
						<select v-model="form.membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
						<label class="form-label" for="membership_level">Membership Level</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
						<label class="form-label" for="title">Title</label>
					</div>
					<div class="form-floating mb-4">
						<textarea v-model="form.description" id="description" class="form-control" placeholder="Enter Description" style="height:150px;"></textarea>
						<label class="form-label" for="description">Description</label>
					</div>
					<div class="form-floating mb-4">
						<div class="mb-4">
							<label class="form-label" for="event_img">Event Image</label>
							<div class="fw-bold text-danger">Recommended Size: width:424px height:261px</div>
							<input
								@change="onFileChange"
								type="file"
								id="event_img"
								name="event_img"
								class="form-control"
								:accept="[
					            'image/jpeg',
					            'image/jpg',
					            'image/png'
					          ]"
							/>
						</div>
						<div class="mb-4">
							<div v-if="form.prev_event_img!=null"
								class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
								style="height: 300px;background-size: contain;background-repeat: no-repeat;background-position: center;"
								:class="{'opacity-25':(form.event_img!=form.prev_event_img && form.prev_event_img!=null && action=='update')}"
							>
								<img :src="form.event_img_url" style="width:100%;" />
							</div>
							<div v-if="form.event_img!=form.prev_event_img && form.prev_event_img!=null && action=='update'" class="text-center text-muted">
								<i class="fa fa-arrow-down fa-2x"></i>
							</div>
							<div>
								<div id="image-preview"
									class="overflow-hidden rounded text-center bg-body-light border-start border-4 border-primary"
									style="background-size: contain;background-repeat: no-repeat;background-position: center;"
									:style="{'height':(form.event_img!=form.prev_event_img)?'300px':'0px'}"
								>
									
								</div>
								<div v-if="form.event_img!=form.prev_event_img && form.prev_event_img!=null && action=='update'" class="text-center"><button @click="removeUploadImage" type="button" class="btn btn-outline-danger btn-sm"><i class="fa fa-times me-2"></i>Remove</button></div>
							</div>
						</div>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.speaker_name" id="speaker_name" name="speaker_name" class="form-control" placeholder="Speaker Name" />
						<label class="form-label" for="speaker_name">Speaker Name</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.event_link" id="event_link" name="event_link" class="form-control" placeholder="Event Link" />
						<label class="form-label" for="event_link">Event Link</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.start_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.start_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="start_datetime">Start DateTime</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.end_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.end_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="end_datetime">End DateTime</label>
					</div>
					<div v-if="form.event_type=='events'" class="form-group mb-4">
						<label class="form-label" for="is_featured">Is feature?</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_on"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_featured"
									id="is_featured_off"
									name="is_featured"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_featured_off">OFF</label>
							</div>
						</div>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_on"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_on">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_off"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_off">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Event</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, reactive } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster';

export default {
	props: {
		category 		: String,
		live_exist		: Number
	},
	setup(props) {

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			event_id 		: 0,
			category 		: null,
			event_type 		: null,
			membership_level: 'ALL',
			is_featured 	: 0,
			is_active 		: 1,
			title 			: null,
			description 	: null,
			event_img 		: null,
			prev_event_img 	: null,
			event_img_url 	: null,
			speaker_name 	: null,
			event_link 		: null,
			start_datetime 	: null,
			end_datetime 	: null,
		})

		const clearUpload = ()=>{
			$("#image-preview").html('');
			$("#event_img").val('');
		}

		const onFileChange = (e) => {
			const image_preview = document.getElementById('image-preview')
			if (e.target.files.length > 0) {
				form.event_img = e.target.files[0]
				const src = URL.createObjectURL(e.target.files[0])
				image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
			} else {
				form.event_img = null
				image_preview.innerHTML = ''
			}
		}

		const removeUploadImage = ()=>{
			form.event_img = form.prev_event_img;
			clearUpload();
		}

		const checkLive = () => {
			Inertia.get(route('admin.events'),{
				is_live 	: 1,
				event_id 	: form.event_id,
			},
			{
				preserveState: true,
				preserveScroll: true,
				only:['live_exist'],
				onSuccess:()=>{
					if(props.live_exist==1)
					{
						toast.show("Live is already exist ", { type: "error"});
					}else{

						if(action.value=='add')
						{
							addContent();
						}else
						{
							updateContent();	
						}
					}
				}
			});
		}

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}
		}

		const addContent = () => {
			form.post(route('admin.post.events'), {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.post('events/'+form.event_id, {
				forceFormData: true,
				preserveState: true,
				preserveScroll: true,
				only:['events','api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setEventContent = (_action,data)=>{

								form.reset();

								if(_action=='update')
								{
									form.event_id 			= data.event_id;
									form.category 			= data.category;
									form.event_type 		= data.event_type;
									form.membership_level 	= data.membership_level;
									form.is_featured 		= data.is_featured;
									form.is_active 			= data.is_active;
									form.title 				= data.title;
									form.description 		= data.description;
									form.event_img 			= data.event_img;
									form.prev_event_img 	= data.prev_event_img;
									form.event_img_url 		= data.event_img_url;
									form.speaker_name 		= data.speaker_name;
									form.event_link 		= data.event_link;
									form.start_datetime 	= data.start_datetime;
									form.end_datetime 		= data.end_datetime;
								}
								
								action.value = _action;
							}


		return {
			toast,
			form,
			modal,
			toggleModal,
			checkLive,
			clearUpload,
			onFileChange,
			removeUploadImage,
			action,
			setEventContent,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
